module.exports = __webpack_public_path__ + "img/bg-portfolio-jmcars.55ab61a7.jpg";